module.exports = __webpack_public_path__ + "static/img/ex_2.e57eece.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ex_2.jpg
// module id = clE6
// module chunks = 1